// extracted by mini-css-extract-plugin
module.exports = {"card":"_02712f2b3b--card--CyU7W"};